import { render, staticRenderFns } from "./MultiFormatListSelector.vue?vue&type=template&id=1448db96&scoped=true&"
import script from "./MultiFormatListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiFormatListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiFormatListSelector.vue?vue&type=style&index=0&id=1448db96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448db96",
  null
  
)

export default component.exports